/**
 * Choose the agent used for session-scoped requests.
 *
 * A full-screen child session is intentionally absent from the top-level
 * session list. Its list-derived agent can therefore be temporarily null
 * while its already-authoritative detail request has completed. Use that
 * verified row as a fallback, but retain a current list value when a user has
 * just switched agents and the detail cache has not refreshed yet.
 */
export function resolveSessionAgentId(
  activeSessionAgentId: string | null | undefined,
  verifiedSessionAgentId: string | null | undefined,
  fallbackAgentId?: string | null,
): string | null {
  return activeSessionAgentId ?? verifiedSessionAgentId ?? fallbackAgentId ?? null;
}
